import { apiCall } from "./index";

export const getDesignations = (page = 1, limit = 10) =>
  apiCall(`/designations?page=${page}&limit=${limit}`);

export const getDesignationById = (designationId) =>
  apiCall(`/designations/${designationId}`);

export const createDesignation = (designationData) =>
  apiCall(`/designations`, "POST", designationData);

export const updateDesignation = (designationId, designationData) =>
  apiCall(`/designations/${designationId}`, "PUT", designationData);

export const deleteDesignation = (designationId) =>
  apiCall(`/designations/${designationId}`, "DELETE");
